import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretLeft } from '@fortawesome/pro-light-svg-icons/faCaretLeft';
import { UserMenu } from '../../user/user-menu';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'cub-side-sub-menu',
  templateUrl: './side-sub-menu.component.html',
  styleUrls: ['./side-sub-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, NgFor, RouterLink, RouterLinkActive, FontAwesomeModule]
})
export class SideSubMenuComponent implements AfterViewInit {
  @ViewChild('panel') panel: ElementRef<HTMLElement>;
  @Output() closed = new EventEmitter<void>();
  @Output() selected = new EventEmitter<void>();
  @Output() pointerEntered = new EventEmitter<void>();
  @Output() pointerLeft = new EventEmitter<void>();
  @Input() focusOnOpen = true;

  private menus: UserMenu[][] = [];
  private path: UserMenu[] = [];
  private menuLabel = '';
  page: { items: UserMenu[]; direction: 'forward' | 'back' } = { items: [], direction: 'forward' };
  faCaretLeft = faCaretLeft;

  @Input() set label(value: string) {
    if (this.menuLabel !== value) {
      this.menuLabel = value;
      this.path = [];
      this.page = { items: [], direction: 'forward' };
    }
  }

  get label(): string {
    return this.menuLabel;
  }

  @Input() set menuList(items: UserMenu[]) {
    const menus = [items];
    const path: UserMenu[] = [];
    let current = items;
    for (const selected of this.path) {
      const matching = current.find(item => item.name === selected.name && item.link === selected.link && item.icon === selected.icon && item.subMenu.length > 0);
      if (!matching) break;
      path.push(matching);
      current = matching.subMenu;
      menus.push(current);
    }
    this.path = path;
    this.menus = menus;
    this.page.items = current;
  }

  get level(): number {
    return this.menus.length - 1;
  }

  constructor(
    private loggerService: LoggerService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    if (this.focusOnOpen) this.focusFirst();
  }

  onPointerEnter(event: PointerEvent): void {
    if (event.pointerType === 'mouse') this.pointerEntered.emit();
  }

  onPointerLeave(event: PointerEvent): void {
    if (event.pointerType === 'mouse') this.pointerLeft.emit();
  }

  menuClick(item: UserMenu): void {
    this.path.push(item);
    this.menus.push(item.subMenu);
    this.page = { items: item.subMenu, direction: 'forward' };
    this.focusNewPage();
  }

  backMenu(): void {
    this.path.pop();
    this.menus.pop();
    this.page = { items: this.menus[this.menus.length - 1], direction: 'back' };
    this.focusNewPage();
  }

  hideMenu(item: UserMenu): void {
    this.loggerService.logPageVisit('left menu clicked', item.name);
    this.selected.emit();
    this.closed.emit();
  }

  openExternal(event: MouseEvent, item: UserMenu): void {
    event.preventDefault();
    this.loggerService.logPageVisit('left menu clicked', item.name);
    let url = item.link;
    if (document.location.href.startsWith('https')) {
      url = url.replace('http://cub/', 'https://cub.centerpoint.com/');
      url = url.replace('http://cubapi/', 'https://cub.centerpoint.com/');
    }
    window.open(url, '_blank', 'noopener');
    this.closed.emit();
  }

  private focusNewPage(): void {
    this.changeDetector.detectChanges();
    this.focusFirst();
  }

  private focusFirst(): void {
    this.panel.nativeElement.querySelector<HTMLElement>('button, a')?.focus();
  }
}
